import { AdjustmentType } from 'enums';

const PaymentCategories = [
    AdjustmentType.CustomerDeduction,
    AdjustmentType.DotBillback,
    AdjustmentType.CustomerDedRepay,
    AdjustmentType.DotCreditToSupplier,
    AdjustmentType.Invoice,
    AdjustmentType.Discount
];

export default PaymentCategories;